"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ReplenishmentPromoManagementUpdateResult_1 = require("../../report/model/ReplenishmentPromoManagementUpdateResult");

var ReplenishmentPromoManagementRowDTOConverter_1 = require("./ReplenishmentPromoManagementRowDTOConverter");

var ReplenishmentPromoManagementUpdateResultConverter_1 = require("./ReplenishmentPromoManagementUpdateResultConverter");

var ReplenishmentPromoManagementUpdateResultConverterImpl =
/*#__PURE__*/
function (_ReplenishmentPromoMa) {
  _inherits(ReplenishmentPromoManagementUpdateResultConverterImpl, _ReplenishmentPromoMa);

  function ReplenishmentPromoManagementUpdateResultConverterImpl() {
    _classCallCheck(this, ReplenishmentPromoManagementUpdateResultConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReplenishmentPromoManagementUpdateResultConverterImpl).apply(this, arguments));
  }

  _createClass(ReplenishmentPromoManagementUpdateResultConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var _this = this;

      return new ReplenishmentPromoManagementUpdateResult_1.ReplenishmentPromoManagementUpdateResult(conversions.asObjectList(source, 'updatedRows', function (mat) {
        return _this.replenishmentPromoManagementRowDTOConverter.toObject(mat, conversions);
      }), conversions.asMap(source, 'errors', function (k) {
        return k;
      }, function (v) {
        return immutable_1.List(v);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        updatedRows: conversions.asObjectArray(source, 'updatedRows', function (mat) {
          return _this2.replenishmentPromoManagementRowDTOConverter.toDocument(mat, conversions);
        }),
        errors: conversions.asKeyValuePairs(source, 'errors', function (k) {
          return k;
        }, function (v) {
          return v.toArray();
        })
      });
      return result;
    }
  }]);

  return ReplenishmentPromoManagementUpdateResultConverterImpl;
}(ReplenishmentPromoManagementUpdateResultConverter_1.ReplenishmentPromoManagementUpdateResultConverter);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", ReplenishmentPromoManagementRowDTOConverter_1.ReplenishmentPromoManagementRowDTOConverter)], ReplenishmentPromoManagementUpdateResultConverterImpl.prototype, "replenishmentPromoManagementRowDTOConverter", void 0);

exports.ReplenishmentPromoManagementUpdateResultConverterImpl = ReplenishmentPromoManagementUpdateResultConverterImpl;